var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacedonateImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 945.76,
    height: 774,
    viewBox: "0, 0, 945.76, 774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 4187.238,
    y1: 986.991,
    x2: 4471.768,
    y2: 315.111,
    gradientTransform: "matrix(1, -0.002, 0.002, 1, -140.75, -65.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    x1: 4319.74,
    y1: 587.292,
    x2: 4319.74,
    y2: 382.672,
    gradientTransform: "matrix(1, 0, 0, 1, -127.12, -62.99)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    x1: -3814.62,
    y1: 975.822,
    x2: -3530.08,
    y2: 303.942,
    gradientTransform: "matrix(-1, 0, 0, 1, -65.49, -65.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    x1: -3682.74,
    y1: 587.292,
    x2: -3682.74,
    y2: 382.672,
    gradientTransform: "matrix(-1, 0, 0, 1, -79.12, -62.99)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 3893.938,
    y1: 1110.281,
    x2: 4178.468,
    y2: 438.401,
    gradientTransform: "matrix(1, -0.002, 0.002, 1, -140.75, -65.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 4026.74,
    y1: 711.292,
    x2: 4026.74,
    y2: 506.672,
    gradientTransform: "matrix(1, 0, 0, 1, -127.12, -62.99)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 3902.621,
    y1: 945,
    x2: 3902.621,
    y2: 837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-3425.24, -250.452)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4355.79,250.452 L4023.29,251.262 C4015.746,251.279 4009.644,257.408 4009.66,264.952 L4011.12,886.832 C4011.131,890.464 4012.587,893.942 4015.167,896.497 C4017.747,899.053 4021.239,900.476 4024.87,900.452 L4357.37,899.642 C4364.914,899.626 4371.017,893.496 4371,885.952 L4369.49,264.062 C4369.462,256.522 4363.331,250.43 4355.79,250.452 z",
    fill: "url(#Gradient_1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4028.144,259.716 L4350.973,258.927 C4358.506,258.909 4364.627,265.001 4364.646,272.534 L4366.123,877.202 C4366.142,884.735 4360.05,890.857 4352.517,890.876 L4029.688,891.664 C4022.155,891.683 4016.033,885.591 4016.014,878.058 L4014.537,273.39 C4014.518,265.856 4020.61,259.735 4028.144,259.716 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4277.55,274.962 C4275.493,288.812 4263.642,299.092 4249.64,299.172 L4128.7,299.452 C4114.709,299.427 4102.825,289.21 4100.7,275.382 L4036.65,275.542 C4029.305,275.559 4023.363,281.527 4023.38,288.872 L4024.77,862.542 C4024.778,866.073 4026.189,869.456 4028.694,871.945 C4031.198,874.434 4034.589,875.825 4038.12,875.812 L4344.12,875.072 C4351.465,875.056 4357.407,869.088 4357.39,861.742 L4356,288.072 C4355.983,280.727 4350.015,274.786 4342.67,274.802 z",
    fill: "#6C63FF",
    id: "03400db2-955d-4119-b6c0-e63250e8f2de",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4294.62,421.682 C4294.614,373.059 4260.287,331.199 4212.606,321.672 C4164.925,312.144 4117.148,337.598 4098.457,382.485 C4079.766,427.373 4095.358,479.213 4135.71,506.342 L4135.77,506.792 C4139.102,509.986 4143.035,512.488 4147.34,514.152 L4147.47,513.702 C4152.24,517.802 4172.35,524.362 4195.47,524.302 L4195.97,524.302 C4210.61,524.302 4226.49,521.722 4240.46,514.162 C4240.46,514.162 4240.58,513.892 4240.77,513.392 C4244.311,511.728 4247.559,509.502 4250.39,506.802 Q4250.47,506.222 4250.55,505.642 C4278.161,486.613 4294.641,455.216 4294.62,421.682 z",
    fill: "url(#Gradient_2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4291.56,421.692 C4291.56,476.335 4247.263,520.632 4192.62,520.632 C4137.977,520.632 4093.68,476.335 4093.68,421.692 C4093.68,367.049 4137.977,322.752 4192.62,322.752 C4247.263,322.752 4291.56,367.049 4291.56,421.692 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.405,283.334 L4223.417,282.223 C4224.521,282.206 4225.43,283.088 4225.446,284.192 L4225.459,285.072 C4225.476,286.177 4224.594,287.086 4223.49,287.102 L4149.478,288.213 C4148.374,288.23 4147.465,287.348 4147.448,286.243 L4147.435,285.363 C4147.418,284.259 4148.3,283.35 4149.405,283.334 z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4244.96,283.85 C4244.985,285.468 4243.693,286.799 4242.075,286.824 C4240.457,286.848 4239.125,285.556 4239.101,283.938 C4239.077,282.32 4240.369,280.988 4241.987,280.964 C4243.605,280.94 4244.936,282.232 4244.96,283.85 z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4105.62,560.342 L4267.62,560.342 L4267.62,578.342 L4105.62,578.342 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4069.62,596.342 L4303.62,596.342 L4303.62,614.342 L4069.62,614.342 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3440.45,250.452 L3772.95,251.262 C3780.494,251.279 3786.596,257.408 3786.58,264.952 L3785.12,886.832 C3785.109,890.464 3783.653,893.942 3781.073,896.497 C3778.493,899.053 3775.001,900.476 3771.37,900.452 L3438.87,899.642 C3431.326,899.626 3425.223,893.496 3425.24,885.952 L3426.75,264.062 C3426.778,256.522 3432.91,250.43 3440.45,250.452 z",
    fill: "url(#Gradient_3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3766.556,891.665 L3443.727,890.876 C3436.194,890.857 3430.102,884.736 3430.12,877.203 L3431.598,272.534 C3431.616,265.001 3437.738,258.909 3445.271,258.928 L3768.1,259.717 C3775.633,259.735 3781.725,265.857 3781.707,273.39 L3780.229,878.058 C3780.211,885.591 3774.089,891.683 3766.556,891.665 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3518.69,274.962 C3520.747,288.812 3532.598,299.092 3546.6,299.172 L3667.53,299.462 C3681.52,299.437 3693.405,289.22 3695.53,275.392 L3759.58,275.552 C3766.925,275.569 3772.867,281.537 3772.85,288.882 L3771.46,862.552 C3771.438,869.898 3765.465,875.834 3758.12,875.812 L3452.12,875.072 C3444.775,875.056 3438.833,869.088 3438.85,861.742 L3440.24,288.072 C3440.257,280.727 3446.225,274.786 3453.57,274.802 z",
    fill: "#6C63FF",
    id: "630d207c-7e3b-460e-9d0a-7242eec8ea7a",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3501.62,421.682 C3501.626,373.059 3535.953,331.199 3583.634,321.672 C3631.315,312.144 3679.092,337.598 3697.783,382.485 C3716.474,427.373 3700.882,479.213 3660.53,506.342 L3660.47,506.792 C3657.138,509.986 3653.205,512.488 3648.9,514.152 L3648.77,513.702 C3644,517.802 3623.89,524.362 3600.77,524.302 L3600.27,524.302 C3585.63,524.302 3569.75,521.722 3555.78,514.162 C3555.78,514.162 3555.66,513.892 3555.47,513.392 C3551.93,511.728 3548.681,509.502 3545.85,506.802 Q3545.77,506.222 3545.69,505.642 C3518.079,486.613 3501.599,455.216 3501.62,421.682 z",
    fill: "url(#Gradient_4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3702.56,421.692 C3702.56,476.335 3658.263,520.632 3603.62,520.632 C3548.977,520.632 3504.68,476.335 3504.68,421.692 C3504.68,367.049 3548.977,322.752 3603.62,322.752 C3658.263,322.752 3702.56,367.049 3702.56,421.692 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3646.751,288.2 L3572.74,287.089 C3571.635,287.073 3570.753,286.164 3570.77,285.06 L3570.783,284.18 C3570.8,283.075 3571.708,282.193 3572.813,282.21 L3646.825,283.321 C3647.929,283.338 3648.811,284.246 3648.794,285.351 L3648.781,286.231 C3648.765,287.335 3647.856,288.217 3646.751,288.2 z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3554.247,280.949 C3555.865,280.973 3557.157,282.304 3557.133,283.922 C3557.108,285.54 3555.777,286.832 3554.159,286.808 C3552.541,286.784 3551.249,285.452 3551.273,283.834 C3551.297,282.216 3552.629,280.924 3554.247,280.949 z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3690.62,578.342 L3528.62,578.342 L3528.62,560.342 L3690.62,560.342 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3726.62,614.342 L3492.62,614.342 L3492.62,596.342 L3726.62,596.342 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4062.79,374.452 L3730.29,375.262 C3722.746,375.279 3716.644,381.408 3716.66,388.952 L3718.12,1010.832 C3718.131,1014.464 3719.587,1017.942 3722.167,1020.497 C3724.747,1023.053 3728.239,1024.476 3731.87,1024.452 L4064.37,1023.642 C4071.914,1023.626 4078.017,1017.497 4078,1009.952 L4076.49,388.062 C4076.462,380.522 4070.33,374.43 4062.79,374.452 z",
    fill: "url(#Gradient_5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3735.147,383.722 L4057.976,382.933 C4065.51,382.915 4071.631,389.007 4071.65,396.54 L4073.127,1001.208 C4073.146,1008.741 4067.054,1014.863 4059.521,1014.881 L3736.691,1015.67 C3729.158,1015.688 3723.037,1009.596 3723.018,1002.063 L3721.541,397.395 C3721.522,389.862 3727.614,383.74 3735.147,383.722 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3984.55,398.962 C3982.493,412.812 3970.642,423.092 3956.64,423.172 L3835.7,423.452 C3821.71,423.427 3809.825,413.21 3807.7,399.382 L3743.65,399.542 C3736.305,399.559 3730.364,405.527 3730.38,412.872 L3731.77,986.542 C3731.778,990.073 3733.189,993.456 3735.694,995.945 C3738.198,998.434 3741.589,999.825 3745.12,999.812 L4051.12,999.072 C4058.465,999.056 4064.406,993.088 4064.39,985.742 L4063,412.072 C4062.983,404.727 4057.015,398.786 4049.67,398.802 z",
    fill: "#6C63FF",
    id: "e707708a-3328-453c-98e2-ff60f305110c",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4001.62,545.682 C4001.614,497.059 3967.287,455.199 3919.606,445.672 C3871.925,436.144 3824.148,461.598 3805.457,506.485 C3786.766,551.373 3802.358,603.213 3842.71,630.342 L3842.77,630.792 C3846.102,633.986 3850.035,636.488 3854.34,638.152 L3854.47,637.702 C3859.24,641.802 3879.35,648.362 3902.47,648.302 L3902.97,648.302 C3917.61,648.302 3933.49,645.722 3947.46,638.162 C3947.46,638.162 3947.58,637.892 3947.77,637.392 C3951.31,635.728 3954.559,633.502 3957.39,630.802 Q3957.47,630.222 3957.55,629.642 C3985.161,610.613 4001.641,579.216 4001.62,545.682 z",
    fill: "url(#Gradient_6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3998.56,545.692 C3998.56,600.335 3954.263,644.632 3899.62,644.632 C3844.977,644.632 3800.68,600.335 3800.68,545.692 C3800.68,491.049 3844.977,446.752 3899.62,446.752 C3954.263,446.752 3998.56,491.049 3998.56,545.692 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3856.399,407.327 L3930.41,406.216 C3931.515,406.2 3932.424,407.082 3932.44,408.186 L3932.453,409.066 C3932.47,410.171 3931.588,411.079 3930.484,411.096 L3856.472,412.207 C3855.368,412.224 3854.459,411.342 3854.442,410.237 L3854.429,409.357 C3854.412,408.253 3855.294,407.344 3856.399,407.327 z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3951.955,407.844 C3951.979,409.462 3950.687,410.793 3949.069,410.817 C3947.451,410.842 3946.12,409.55 3946.095,407.932 C3946.071,406.314 3947.363,404.982 3948.981,404.958 C3950.599,404.934 3951.93,406.226 3951.955,407.844 z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3812.62,684.342 L3974.62,684.342 L3974.62,702.342 L3812.62,702.342 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3776.62,720.342 L4010.62,720.342 L4010.62,738.342 L3776.62,738.342 z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3956.621,891 C3956.621,920.823 3932.444,945 3902.621,945 C3872.797,945 3848.621,920.823 3848.621,891 C3848.621,861.177 3872.797,837 3902.621,837 C3932.444,837 3956.621,861.177 3956.621,891 z",
    fill: "url(#Gradient_7)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3947.621,891 C3947.621,915.853 3927.473,936 3902.621,936 C3877.768,936 3857.621,915.853 3857.621,891 C3857.621,866.147 3877.768,846 3902.621,846 C3927.473,846 3947.621,866.147 3947.621,891 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3861.82,586.372 C3861.82,586.372 3838.25,588.302 3844.48,631.252 C3847.711,634.35 3851.525,636.777 3855.7,638.392 L3868.96,593.512 z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3938.32,586.372 C3938.32,586.372 3961.89,588.302 3955.66,631.252 C3952.429,634.35 3948.615,636.777 3944.44,638.392 L3931.18,593.512 z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3862.84,515.992 C3862.84,515.992 3851.62,548.632 3845.5,545.572 C3845.5,545.572 3904.5,596.572 3956.68,545.572 C3956.68,545.572 3947.5,529.252 3934.24,515.992 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3944.56,512.932 C3944.56,537.155 3924.923,556.792 3900.7,556.792 C3876.477,556.792 3856.84,537.155 3856.84,512.932 C3856.84,488.709 3876.477,469.072 3900.7,469.072 C3924.923,469.072 3944.56,488.709 3944.56,512.932 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3937.87,586.372 L3861.37,586.372 L3854.23,616.972 C3854.23,616.972 3850.04,631.142 3855.23,637.372 C3860.42,643.602 3909.18,657.772 3944.99,638.372 C3948.105,630.211 3948.457,621.253 3945.99,612.872 C3941.91,598.592 3944.99,611.872 3944.99,611.872 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3938.89,586.372 L3862.39,586.372 L3855.25,616.972 C3855.25,616.972 3851.06,631.142 3856.25,637.372 C3861.44,643.602 3910.2,657.772 3946.01,638.372 C3949.125,630.211 3949.477,621.253 3947.01,612.872 C3942.93,598.592 3946.01,611.872 3946.01,611.872 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3938.32,586.372 L3861.82,586.372 L3854.68,616.972 C3854.68,616.972 3850.49,631.142 3855.68,637.372 C3860.87,643.602 3909.63,657.772 3945.44,638.372 C3948.555,630.211 3948.906,621.253 3946.44,612.872 C3942.36,598.592 3945.44,611.872 3945.44,611.872 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3885.24,560.992 L3915.84,560.992 L3915.84,585.442 C3915.84,593.892 3908.99,600.742 3900.54,600.742 L3900.54,600.742 C3892.09,600.742 3885.24,593.892 3885.24,585.442 L3885.24,560.992 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3885.24,559.852 L3915.84,559.852 L3915.84,584.332 C3915.84,592.782 3908.99,599.632 3900.54,599.632 L3900.54,599.632 C3892.09,599.632 3885.24,592.782 3885.24,584.332 L3885.24,559.852 z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3885.34,564.272 C3895.202,567.959 3906.059,567.987 3915.94,564.352 L3915.94,560.592 L3885.34,560.592 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3944.56,522.452 C3944.56,546.675 3924.923,566.312 3900.7,566.312 C3876.477,566.312 3856.84,546.675 3856.84,522.452 C3856.84,498.229 3876.477,478.592 3900.7,478.592 C3924.923,478.592 3944.56,498.229 3944.56,522.452 z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3858.76,505.792 L3942.4,505.792 C3942.4,505.792 3935.26,472.022 3903.64,474.172 C3872.02,476.322 3858.76,505.792 3858.76,505.792 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3861.82,520.582 C3861.82,524.807 3859.993,528.232 3857.74,528.232 C3855.487,528.232 3853.66,524.807 3853.66,520.582 C3853.66,516.357 3855.487,512.932 3857.74,512.932 C3859.993,512.932 3861.82,516.357 3861.82,520.582 z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3947.5,520.582 C3947.5,524.807 3945.673,528.232 3943.42,528.232 C3941.167,528.232 3939.34,524.807 3939.34,520.582 C3939.34,516.357 3941.167,512.932 3943.42,512.932 C3945.673,512.932 3947.5,516.357 3947.5,520.582 z",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3858.76,506.932 L3942.4,506.932 C3942.4,506.932 3935.26,473.162 3903.64,475.312 C3872.02,477.462 3858.76,506.932 3858.76,506.932 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.82,460.372 C4149.82,460.372 4126.25,462.302 4132.48,505.252 C4135.711,508.35 4139.525,510.777 4143.7,512.392 L4156.96,467.512 z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4226.32,460.372 C4226.32,460.372 4249.89,462.302 4243.66,505.252 C4240.429,508.35 4236.615,510.777 4232.44,512.392 L4219.18,467.512 z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4232.56,386.932 C4232.56,411.155 4212.923,430.792 4188.7,430.792 C4164.477,430.792 4144.84,411.155 4144.84,386.932 C4144.84,362.709 4164.477,343.072 4188.7,343.072 C4212.923,343.072 4232.56,362.709 4232.56,386.932 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4225.87,460.372 L4149.37,460.372 L4142.23,490.972 C4142.23,490.972 4138.04,505.142 4143.23,511.372 C4148.42,517.602 4197.18,531.772 4232.99,512.372 C4236.105,504.211 4236.457,495.253 4233.99,486.872 C4229.91,472.592 4232.99,485.872 4232.99,485.872 z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4226.89,460.372 L4150.39,460.372 L4143.25,490.972 C4143.25,490.972 4139.06,505.142 4144.25,511.372 C4149.44,517.602 4198.2,531.772 4234.01,512.372 C4237.125,504.211 4237.477,495.253 4235.01,486.872 C4230.93,472.592 4234.01,485.872 4234.01,485.872 z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4226.32,460.372 L4149.82,460.372 L4142.68,490.972 C4142.68,490.972 4138.49,505.142 4143.68,511.372 C4148.87,517.602 4197.63,531.772 4233.44,512.372 C4236.555,504.211 4236.906,495.253 4234.44,486.872 C4230.36,472.592 4233.44,485.872 4233.44,485.872 z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4173.24,434.992 L4203.84,434.992 L4203.84,459.442 C4203.84,467.892 4196.99,474.742 4188.54,474.742 L4188.54,474.742 C4180.09,474.742 4173.24,467.892 4173.24,459.442 L4173.24,434.992 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4173.24,433.852 L4203.84,433.852 L4203.84,458.332 C4203.84,466.782 4196.99,473.632 4188.54,473.632 L4188.54,473.632 C4180.09,473.632 4173.24,466.782 4173.24,458.332 L4173.24,433.852 z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4173.34,438.272 C4183.202,441.959 4194.059,441.987 4203.94,438.352 L4203.94,434.592 L4173.34,434.592 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4232.56,396.452 C4232.56,420.675 4212.923,440.312 4188.7,440.312 C4164.477,440.312 4144.84,420.675 4144.84,396.452 C4144.84,372.229 4164.477,352.592 4188.7,352.592 C4212.923,352.592 4232.56,372.229 4232.56,396.452 z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4146.76,380.932 L4230.4,380.932 C4230.4,380.932 4223.26,347.162 4191.64,349.312 C4160.02,351.462 4146.76,380.932 4146.76,380.932 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4146.76,379.792 L4230.4,379.792 C4230.4,379.792 4223.26,346.022 4191.64,348.172 C4160.02,350.322 4146.76,379.792 4146.76,379.792 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.82,394.582 C4149.82,398.807 4147.993,402.232 4145.74,402.232 C4143.487,402.232 4141.66,398.807 4141.66,394.582 C4141.66,390.357 4143.487,386.932 4145.74,386.932 C4147.993,386.932 4149.82,390.357 4149.82,394.582 z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4235.5,394.582 C4235.5,398.807 4233.673,402.232 4231.42,402.232 C4229.167,402.232 4227.34,398.807 4227.34,394.582 C4227.34,390.357 4229.167,386.932 4231.42,386.932 C4233.673,386.932 4235.5,390.357 4235.5,394.582 z",
    fill: "#FDB797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4153.26,357.452 C4154.158,354.116 4156.143,351.174 4158.9,349.092 C4161.04,347.612 4163.59,346.892 4166.05,346.032 C4169.68,344.737 4173.163,343.061 4176.44,341.032 C4180.16,338.742 4183.65,335.982 4187.75,334.462 C4194.75,331.852 4202.64,333.262 4209.92,335.132 C4211.733,335.515 4213.479,336.165 4215.1,337.062 C4216.866,338.284 4218.42,339.787 4219.7,341.512 L4231.24,355.452 C4232.342,356.675 4233.305,358.016 4234.11,359.452 C4234.805,360.886 4235.248,362.428 4235.42,364.012 C4235.834,366.573 4235.402,369.199 4234.19,371.492 C4232.19,374.822 4228.19,376.492 4224.35,376.652 C4220.51,376.812 4216.71,375.652 4213,374.602 C4201,371.102 4188.94,367.842 4176.55,366.382 C4170.397,365.623 4164.189,365.423 4158,365.782 C4156.06,365.912 4153.49,366.782 4152.31,364.782 C4151.28,363.142 4152.73,359.142 4153.26,357.452 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3564.82,459.372 C3564.82,459.372 3541.25,461.302 3547.48,504.252 C3550.711,507.35 3554.525,509.777 3558.7,511.392 L3571.96,466.512 z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3641.32,459.372 C3641.32,459.372 3664.89,461.302 3658.66,504.252 C3655.429,507.35 3651.615,509.777 3647.44,511.392 L3634.18,466.512 z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3565.84,388.992 C3565.84,388.992 3564.03,394.272 3561.46,400.382 C3555.85,413.752 3562.25,465.092 3575.68,470.562 C3590.74,476.702 3610.56,480.632 3631.14,473.132 C3649.03,466.612 3654.54,408.132 3641.9,393.942 C3640.42,392.272 3638.9,390.612 3637.25,389.002 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3647.56,385.932 C3647.56,410.155 3627.923,429.792 3603.7,429.792 C3579.477,429.792 3559.84,410.155 3559.84,385.932 C3559.84,361.709 3579.477,342.072 3603.7,342.072 C3627.923,342.072 3647.56,361.709 3647.56,385.932 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3640.87,459.372 L3564.37,459.372 L3557.23,489.972 C3557.23,489.972 3553.04,504.142 3558.23,510.372 C3563.42,516.602 3612.18,530.772 3647.99,511.372 C3651.105,503.211 3651.457,494.253 3648.99,485.872 C3644.91,471.592 3647.99,484.872 3647.99,484.872 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3641.89,459.372 L3565.39,459.372 L3558.25,489.972 C3558.25,489.972 3554.06,504.142 3559.25,510.372 C3564.44,516.602 3613.2,530.772 3649.01,511.372 C3652.125,503.211 3652.477,494.253 3650.01,485.872 C3645.93,471.592 3649.01,484.872 3649.01,484.872 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3641.32,459.372 L3564.82,459.372 L3557.68,489.972 C3557.68,489.972 3553.49,504.142 3558.68,510.372 C3563.87,516.602 3612.63,530.772 3648.44,511.372 C3651.555,503.211 3651.906,494.253 3649.44,485.872 C3645.36,471.592 3648.44,484.872 3648.44,484.872 z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3588.24,433.992 L3618.84,433.992 L3618.84,458.442 C3618.84,466.892 3611.99,473.742 3603.54,473.742 L3603.54,473.742 C3595.09,473.742 3588.24,466.892 3588.24,458.442 L3588.24,433.992 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3588.24,432.852 L3618.84,432.852 L3618.84,457.332 C3618.84,465.782 3611.99,472.632 3603.54,472.632 L3603.54,472.632 C3595.09,472.632 3588.24,465.782 3588.24,457.332 L3588.24,432.852 z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3588.34,437.272 C3598.202,440.959 3609.059,440.987 3618.94,437.352 L3618.94,433.592 L3588.34,433.592 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3647.56,395.452 C3647.56,419.675 3627.923,439.312 3603.7,439.312 C3579.477,439.312 3559.84,419.675 3559.84,395.452 C3559.84,371.229 3579.477,351.592 3603.7,351.592 C3627.923,351.592 3647.56,371.229 3647.56,395.452 z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3561.76,378.792 L3645.4,378.792 C3645.4,378.792 3638.26,345.022 3606.64,347.172 C3575.02,349.322 3561.76,378.792 3561.76,378.792 z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3564.82,393.582 C3564.82,397.807 3562.993,401.232 3560.74,401.232 C3558.487,401.232 3556.66,397.807 3556.66,393.582 C3556.66,389.357 3558.487,385.932 3560.74,385.932 C3562.993,385.932 3564.82,389.357 3564.82,393.582 z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3650.5,393.582 C3650.5,397.807 3648.673,401.232 3646.42,401.232 C3644.167,401.232 3642.34,397.807 3642.34,393.582 C3642.34,389.357 3644.167,385.932 3646.42,385.932 C3648.673,385.932 3650.5,389.357 3650.5,393.582 z",
    fill: "#BE7C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3561.76,379.932 L3645.4,379.932 C3645.4,379.932 3638.26,346.162 3606.64,348.312 C3575.02,350.462 3561.76,379.932 3561.76,379.932 z",
    fill: "#000000",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacedonateImg3);
export default __webpack_public_path__ + "static/media/facedonate_img_3.0566fc55.svg";
export { ForwardRef as ReactComponent };